var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKelasPengenalan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5C0.5 2.20451 1.3044 1.0734 2.5 0.468238V24.5C2.5 25.4665 3.39543 26.25 4.5 26.25H20.5C21.6046 26.25 22.5 25.4665 22.5 24.5V3.5C22.5 2.5335 21.6046 1.75 20.5 1.75H16.5V0H20.5C22.7091 0 24.5 1.567 24.5 3.5V24.5C24.5 26.433 22.7091 28 20.5 28H4.5C2.29086 28 0.5 26.433 0.5 24.5V3.5ZM4.5 0V11.375C4.5 11.7064 4.714 12.0094 5.05279 12.1576C5.39157 12.3058 5.79698 12.2739 6.1 12.075L9.5 9.84375L12.9 12.075C13.203 12.2739 13.6084 12.3058 13.9472 12.1576C14.286 12.0094 14.5 11.7064 14.5 11.375V0H4.5ZM6.5 9.625V1.75H12.5V9.625L10.1 8.05C9.74444 7.81667 9.25556 7.81667 8.9 8.05L6.5 9.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKelasPengenalan);
export default __webpack_public_path__ + "static/media/icKelasPengenalan.3f5c4208b1821fd2099680d825626dc5.svg";
export { ForwardRef as ReactComponent };